import axiosInstance from "../../utils/axiosCompany";

export const CreateMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/create-menu-item", values);
}

export const GetMenuItemsList = async (values) => {
    return await axiosInstance().post("company/menu-item/list-items", values);
}



export const GetSingleMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/get-single-menu-item", values);
}

export const editMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/update-menu-item", values)
}

export const ChangeMenuItemsStatus = async (values) => {
    return await axiosInstance().post("company/menu-item/change-menu-item-status", values)
}

export const DeleteMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/delete-menu-item", values);
}

export const ImportedMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/validate-import-file", values);
}

export const ExportMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/export-all-menu-items", values);
}
export const GetMenuItems = async (values) => {
    return await axiosInstance().post("company/menu-item/get-menu-items", values);
}
export const GetMenuItemsWithReciepes = async (values) => {
    return await axiosInstance().post("company/menu-item/get-all-menu-items-with-reciepes", values);
}

export const CancelMenuItemScheduleDate = async (values) => {
    return await axiosInstance().post("company/menu-item/cancel-menu-item-schedule-date", values);
}
// Recipes imported from a spreadsheet: the list page parses and validates the
// sheet, then posts { brand_id, recipes } where recipes is a JSON array of
// { menu_item_id, recipe_sku, quantity, order_mode_short_codes }.
export const UpdateMenuItemRecipes = async (values) => {
    return await axiosInstance().post("company/menu-item/import-recipes", values);
}

// Existing recipes for the brand, used to pre-fill the import template.
// Returns { recipe_list, order_modes }.
export const ExportMenuItemRecipes = async (values) => {
    return await axiosInstance().post("company/menu-item/export-recipes", values);
}

// Base, default and outlet specific prices of the menu items the list's filters
// match, for the Pricing sample file. Returns { rows }.
export const ExportMenuItemsPricing = async (values) => {
    return await axiosInstance().post("company/menu-item/export-menu-items-pricing", values);
}

// Menu item prices parsed from the pricing sheet on the list page. Posts
// { brand_id, prices, default_prices, specific_prices }, each a JSON array:
// prices of { id, price }; default_prices and specific_prices of
// { id, aggregator_id, order_mode_id, price }, specific_prices rows also with
// outlet_short_codes [] — the data, not the file.
export const ImportMenuItemsPricing = async (values) => {
    return await axiosInstance().post("company/menu-item/import-menu-items-pricing", values);
}
